export const getInitials = (firstName: string, lastName: string): string => {
    const firstNameInitial = firstName !== null ? firstName.charAt(0) : '';
    const lastNameInitial = lastName != null ? lastName.charAt(0) : '';
    return `${firstNameInitial}${lastNameInitial}`;
};
